const flyIn = function() {
	let flies = document.querySelectorAll('.fly-in-top, .fly-in-right, .fly-in-bottom, .fly-in-left');
	// With reduced motion it's all just there, not revealed one piece at a time.
	if (document.documentElement.dataset.motion === 'reduce') {
		flies.forEach(el => el.classList.add('in'));
		return;
	}
	// Wait one frame so the starting (off-screen) state is painted and the
	// first element animates too, then stagger the rest.
	requestAnimationFrame(() => requestAnimationFrame(() => {
		for (let i=0;i < flies.length; i++) {
			setTimeout(function(){
				flies[i].classList.add('in');
			}, i * 200);
		}
	}));
}

const navToggleInit = function() {
	const nav = document.getElementById("main-nav");
	const toggle = document.getElementById("main-nav-toggle");
	toggle.addEventListener('click', () => {
		if (!(nav.classList.toString().indexOf('open') > -1)) {
			nav.classList.add('transition');
			toggle.classList.add('transition');
			setTimeout(() => {
				nav.classList.add('open');
				toggle.classList.add('open');
				toggle.textContent ='Close menu';
				toggle.setAttribute('aria-expanded', 'true');
			}, 10);
			setTimeout(() => {
				nav.classList.remove('transition');
			}, 1010);
		} else {
			nav.classList.add('transition');
			toggle.classList.add('transition');
			setTimeout(() => {
				nav.classList.remove('open');
				toggle.classList.remove('open');
				toggle.textContent ='Open menu';
				toggle.setAttribute('aria-expanded', 'false');
			}, 10);
			setTimeout(() => {
				nav.classList.remove('transition');
				toggle.classList.remove('transition');
			}, 1010);
		}
	});	
}

// The accessibility settings panel (templates/a11y-panel.php). The preferences
// themselves are kept by window.a11y, from scripts/a11y-prefs.js in <head>.
const a11yPanelInit = function() {
	const toggle = document.getElementById('a11y-toggle');
	const dialog = document.getElementById('a11y-panel');
	if (!window.a11y || !toggle || !dialog) {
		return;
	}
	const form = dialog.querySelector('form');
	const deviceNote = document.getElementById('a11y-device-motion');
	const sync = () => {
		form.elements.motion.value = a11y.get('motion');
		form.elements.text.value = a11y.get('text');
		form.elements.links.checked = a11y.get('links');
		form.elements.font.checked = a11y.get('font');
		deviceNote.textContent = a11y.deviceReducesMotion()
			? 'Your device asks for reduced motion'
			: 'Your device allows motion';
	};
	form.addEventListener('change', (event) => {
		const input = event.target;
		a11y.set(input.name, input.type === 'checkbox' ? input.checked : input.value);
	});
	form.querySelector('.a11y-reset').addEventListener('click', () => a11y.reset());
	// Keep the panel right when the device setting or another tab changes things.
	document.addEventListener('a11ychange', sync);
	toggle.addEventListener('click', () => {
		sync();
		dialog.showModal();
	});
	// The form fills the dialog, so this is a click on the backdrop.
	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) {
			dialog.close();
		}
	});
}

// Cookie consent (lib/cookies.php). window.consent.allowed(id) says whether an
// optional category of cookies may be used; "consentchange" fires on document
// when the visitor decides. Necessary cookies don't need asking.
const consentInit = function() {
	const read = () => {
		const match = document.cookie.match(/(?:^|;\s*)consent=([^;]*)/);
		return new URLSearchParams(match ? decodeURIComponent(match[1]) : '');
	};
	window.consent = {
		allowed: id => read().get(id) === '1'
	};

	const bar = document.getElementById('cookie-bar');
	if (!bar) {
		return;
	}
	// Keep focused elements clear of the bar while it's showing.
	const root = document.documentElement;
	const measure = () => root.style.setProperty('--cookie-bar-height', bar.offsetHeight + 'px');
	measure();
	new ResizeObserver(measure).observe(bar);

	const form = bar.querySelector('form');
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		const data = new FormData(form, event.submitter);
		fetch(form.action, { method: 'POST', body: data, headers: { 'X-Requested-With': 'fetch' } })
			.then((response) => {
				// Only /cookies answers 204; anything else didn't save.
				if (response.status !== 204) {
					throw new Error(response.status);
				}
				// Confirm in place, with focus on the confirmation so it's read out.
				const done = document.createElement('div');
				done.className = 'cookie-bar-inner box box-pad';
				done.tabIndex = -1;
				done.innerHTML = '<p>Saved. You can change this any time on the <a href="/cookies">Cookies page</a>.</p>'
					+ '<p class="button-row"><button type="button" class="primary">Close</button></p>';
				done.querySelector('button').addEventListener('click', () => {
					bar.remove();
					root.style.removeProperty('--cookie-bar-height');
					const main = document.getElementById('main');
					if (main) {
						main.tabIndex = -1;
						main.focus({ preventScroll: true });
					}
				});
				form.replaceWith(done);
				// The bar's place in the page is at the end, so don't scroll there.
				done.focus({ preventScroll: true });
				document.dispatchEvent(new CustomEvent('consentchange'));
			})
			.catch(() => {
				// Fall back to an ordinary post, which saves and comes back here.
				const choice = document.createElement('input');
				choice.type = 'hidden';
				choice.name = 'consent';
				choice.value = data.get('consent');
				form.appendChild(choice);
				form.submit();
			});
	});
}

// reCAPTCHA costs a render-blocking request, ~350KB of script and a set of
// third-party cookies, so it is only fetched once someone starts using a form.
const recaptchaInit = function() {
	const button = document.querySelector('button[data-sitekey]');
	if (!button || !button.form) {
		return;
	}
	const form = button.form;
	const key = button.dataset.sitekey;
	let loading = null;
	const load = () => {
		if (!loading) {
			loading = new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(key);
				script.onload = () => grecaptcha.ready(resolve);
				script.onerror = () => {
					loading = null;
					reject();
				};
				document.head.appendChild(script);
			});
		}
		return loading;
	};
	form.addEventListener('focusin', () => load().catch(() => {}), { once: true });
	// Fetching reCAPTCHA, getting a token and the server sending the email take
	// a few seconds between them. Dim the form and say so until the next page,
	// which carries the thank-you message, replaces this one.
	const status = document.createElement('p');
	status.className = 'form-sending';
	status.setAttribute('role', 'status');
	const showSending = () => {
		if (!status.firstChild) {
			const spinner = document.createElement('span');
			spinner.className = 'spinner';
			spinner.setAttribute('aria-hidden', 'true');
			const text = document.createElement('span');
			text.className = 'box box-pad';
			text.textContent = 'Sending your message…';
			status.append(spinner, text);
		}
		form.classList.add('sending');
		form.setAttribute('aria-busy', 'true');
		form.appendChild(status);
	};
	// Coming back with the Back button restores this page as it was left.
	window.addEventListener('pageshow', (event) => {
		if (event.persisted) {
			form.classList.remove('sending');
			form.removeAttribute('aria-busy');
			status.remove();
			button.disabled = false;
		}
	});
	// Only fires once the browser's own field validation has passed.
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		button.disabled = true;
		showSending();
		load()
			.then(() => grecaptcha.execute(key, { action: button.dataset.action }))
			.then((token) => {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'g-recaptcha-response';
				input.value = token;
				form.appendChild(input);
			})
			.catch(() => {})
			// Without a token the server rejects the message and says so.
			.then(() => form.submit());
	});
}

// This script is deferred, so the page is already parsed: show it and wire up
// the menu now instead of waiting for every image and font.
navToggleInit();
a11yPanelInit();
consentInit();
flyIn();
recaptchaInit();

window.onload = () => {
	if (window.afterLoad){
		window.afterLoad();
	}
};